import { Section } from '@/components/ui/layouts/sections/Section';
import {
  carouselCardsSettings,
  roundCarouselBlock,
} from '@mage-ui/styled-system/recipes';
import { InstancesCarousel } from '../InstancesCarousel';

export const RoundCarouselBlock = ({ data, ...props }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
        epi: data?.fields?.epi,
        intro: data?.fields?.intro,
      }}
      className={roundCarouselBlock().root}
    >
      <InstancesCarousel
        indicatorThreshold={3}
        settings={carouselCardsSettings()}
        instances={data?.relations?.RoundCarouselList}
        {...props}
      />
    </Section>
  );
};
